// extracted by mini-css-extract-plugin
export default {"mapImg":"Maps_mapImg__woE8N"};